/**
 * ExternalAdminRedirect — All internal /admin/* routes redirect to the
 * standalone geoVINUM Admin back-office deployed at https://geovinum.io/admin.
 * The actual admin panel lives in a separate project; this app only exposes the
 * API endpoints consumed by that back-office.
 */
import { useEffect } from "react";

export const EXTERNAL_ADMIN_URL = "https://geovinum.io/admin";

export default function ExternalAdminRedirect() {
  useEffect(() => {
    window.location.replace(EXTERNAL_ADMIN_URL);
  }, []);
  return (
    <div className="max-w-lg mx-auto px-6 py-24 text-center" data-testid="external-admin-redirect">
      <div className="text-4xl mb-4">🔐</div>
      <h1 className="font-display text-2xl text-[#1F3A5F]">Back-office geoVINUM</h1>
      <p className="text-sm text-[#4A5568] mt-3">
        L'administration a déménagé. Redirection en cours vers{" "}
        <a href={EXTERNAL_ADMIN_URL} className="text-[#E5276A] font-bold underline">
          {EXTERNAL_ADMIN_URL}
        </a>
        …
      </p>
    </div>
  );
}
